const STORAGE_PREFIX = "kan_party_game_v1";

export type PartyGameCacheEnvelope<T = unknown> = {
  v: 1;
  shellId: string;
  savedAt: string;
  data: T;
};

export function partyGameCacheStorageKey(shellId: string): string {
  return `${STORAGE_PREFIX}_${shellId}`;
}

export function readPartyGameCache<T = unknown>(shellId: string): PartyGameCacheEnvelope<T> | null {
  try {
    const raw = localStorage.getItem(partyGameCacheStorageKey(shellId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PartyGameCacheEnvelope<T>;
    if (!parsed || parsed.v !== 1 || parsed.shellId !== shellId || parsed.data == null) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writePartyGameCache(shellId: string, data: unknown): void {
  try {
    const envelope: PartyGameCacheEnvelope = {
      v: 1,
      shellId,
      savedAt: new Date().toISOString(),
      data,
    };
    localStorage.setItem(partyGameCacheStorageKey(shellId), JSON.stringify(envelope));
  } catch {
    /* quota or private mode */
  }
}

export function clearPartyGameCache(shellId: string): void {
  try {
    localStorage.removeItem(partyGameCacheStorageKey(shellId));
  } catch {
    /* ignore */
  }
}
